import { ActionModal } from "@/shared/base/components/ActionModal/ActionModal";
import { ModalActionButton } from "@/shared/base/components/ModalActionButton/ModalActionButton";
import { useToggle } from "@/shared/base/hooks/useToggle";
import { Box, Divider, Link, Stack, Typography, useTheme } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

interface Props {
  isOpen: boolean;
  onClose?: () => void;
}

export function SessionTimeoutModal(props: Props) {
  const theme = useTheme();

  return (
    <ActionModal
      isOpen={props.isOpen}
      onClose={props.onClose}
      renderHeader={() => {
        return (
          <Stack
            py={2}
            px={3}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography
              variant="subtitle1"
              color="text.primary"
              fontWeight={600}
              marginTop={"0px !important"}
            >
              Session Timeout!
            </Typography>
          </Stack>
        );
      }}
      renderBody={() => {
        return (
          <Box>
            <Divider />
            <Box p={3}>
              <Typography variant="body1" color="text.secondary">
                Your session has expired. Please login again.
              </Typography>
            </Box>
            <Divider />
          </Box>
        );
      }}
      renderFooter={() => {
        return (
          <Stack
            p={2}
            direction={"row"}
            justifyContent={"flex-end"}
            spacing={2}
          >
            <Box width={"120px"}>
              <ModalActionButton variant="primary" onClick={props.onClose}>
                Close
              </ModalActionButton>
            </Box>
          </Stack>
        );
      }}
    />
  );
}
